import { saveConfig } from './utils';

function checkTransitions (tempConfigFile, actionID) {
  return new Promise((resolve, reject) => {
    const transitionsAffected = [];

    tempConfigFile.transitions.forEach(transition => {
      if (transition.actions.filter(action => action.id === actionID).length) { transitionsAffected.push(transition); }
    });

    resolve({
      actionID: actionID,
      transitionsAffected: transitionsAffected
    });
  });
}

export const onDelete = async (id, config, setAffectedDependencies, setShowModal, saveTempConfigFile, setNotification, open, toggleForm) => {
  const aux = await checkTransitions(config, id);
  setAffectedDependencies(aux);
  if (
    (aux.actionsAffected && aux.actionsAffected.length) ||
    (aux.transitionsAffected && aux.transitionsAffected.length)
  ) {
    setShowModal(true);
  } else {
    const configFile = {
      ...config,
      actions: config.actions.filter(action => action.id !== id)
    };
    saveConfig(configFile, saveTempConfigFile, setNotification, open, toggleForm);
  }
};

export function deleteActionsProcess (tempConfigFile, affectedDependencies) {
  return new Promise((resolve, reject) => {
    const newTempConfigFile = tempConfigFile;

    affectedDependencies.transitionsAffected.forEach(element => {
      newTempConfigFile.transitions.splice(
        newTempConfigFile.transitions.findIndex(item => item.id === element.id),
        1
      );
    });

    newTempConfigFile.actions.splice(
      newTempConfigFile.actions.findIndex(
        item => item.id === affectedDependencies.actionID
      ),
      1
    );

    resolve({ ...newTempConfigFile });
  });
}
